import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';

// * The lower the zoom number, the farther out the map is zoomed

const Map = ({
  children = null,
  zoom = 5,
  center = { lat: 54.4159862, lng: -110.17902 },
  onLoad = null,
}) => {
  return (
    <GoogleMapReact
      zoom={zoom}
      center={center}
      bootstrapURLKeys={{
        key: [`${process.env.GATSBY_GOOGLE_MAPS_KEY}`],
        libraries: ['places', 'geometry'],
      }}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => onLoad(map, maps)}
    >
      {children}
    </GoogleMapReact>
  );
};

Map.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  onLoad: PropTypes.func,
  zoom: PropTypes.number,
  center: PropTypes.shape(),
};

export default Map;
